/**
 * Analyzer note: the named primitive aliases in this file are the public
 * BRC-100 wire vocabulary. Their names and JSDoc constraints feed generated
 * API documentation and communicate semantics that primitive types cannot.
 * S6564 is therefore suppressed on those declarations instead of erasing the
 * public protocol vocabulary.
 */
/**
 * @enum {number} SecurityLevels
 *
 * Silent = 0 Silently grants the request with no user interation.
 * App = 1 Requires user approval for every application.
 * Counterparty = 2 Requires user approval per counterparty per application.
 */
export var SecurityLevels;
(function (SecurityLevels) {
    SecurityLevels[SecurityLevels["Silent"] = 0] = "Silent";
    SecurityLevels[SecurityLevels["App"] = 1] = "App";
    SecurityLevels[SecurityLevels["Counterparty"] = 2] = "Counterparty";
})(SecurityLevels || (SecurityLevels = {}));
//# sourceMappingURL=Wallet.interfaces.js.map